import type { ConfluenceFolder } from '../../types';

export const isConfluenceFolder = (entity: any): entity is ConfluenceFolder => {
	return entity.__typename === 'ConfluenceFolder';
};

export const getConfluenceFolderLink = (folder: ConfluenceFolder): string | null => {
	const { base, webUi } = folder.links ?? {};

	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}

	return `${base}${webUi}`;
};
